import { messages } from './swStore';

const sentences = {};

function getUtterance(id, text) {
  if (sentences[id]) {
    return sentences[id];
  }

  const utterance = new SpeechSynthesisUtterance(text);
  utterance.rate = 1.5;
  utterance.onerror = function utteranceError(e) {
    messages.update((prev) => [e.error, ...prev]);
    alert(e.error);
  };

  sentences[id] = utterance;
  return sentences[id];
}

(function initAnnouncer() {
  getUtterance('start', 'Start');
  getUtterance('break', 'Break');
  getUtterance('end', 'Timer Completed');
}());

export function speakRound() {
  const audio = document.getElementById('audio-start');
  console.log('Audio round: ', audio);
  if (audio) {
    audio.play()
  }
  // const utterance = getUtterance('start');
  // speechSynthesis.speak(utterance);
}

export function speakBreak() {
  const audio = document.getElementById('audio-break');
  console.log('Audio break: ', audio);
  if (audio) {
    audio.play()
  }
  // const utterance = getUtterance('break');
  // speechSynthesis.speak(utterance);
}

export function speakComplete() {
  const utterance = getUtterance('end');
  speechSynthesis.speak(utterance);
}
